// extracted by mini-css-extract-plugin
export default {"container":"LotteryTable_container__R14Bq","used":"LotteryTable_used__DMcWV","notUsed":"LotteryTable_notUsed__6y-9F","datagrid_container":"LotteryTable_datagrid_container__NjUBX"};